import PropTypes from "prop-types";
import tags from "@constants/sitemaps/tags";
import SitemapPage, { breadcrumbs } from "../index.page";

export default function SitemapDirectoryArticles(props) {
  const { items, metadata } = props;

  return (
    <SitemapPage metadata={metadata}>
      <ul className="divide-y-2 divide-blue-100">
        {items.map(item => (
          <li className="py-6" key={item.slug}>
            <header>
              <a
                href={`/sitemaps/articles/${item.slug}`}
                className="text-lg font-semibold"
              >
                {item.label}
                {item.recirc && (
                  <span className="block text-sm text-blue-400 font-light">
                    Learn more about {item.label}
                  </span>
                )}
              </a>
            </header>

            {item.children.length > 0 && (
              <div className="mt-2 grid grid-cols-4 gap-1">
                {item.children.map(child => (
                  <a
                    key={child.slug}
                    href={`/sitemaps/articles/${child.slug}`}
                    className="text-slate hover:text-black"
                  >
                    {child.label}
                  </a>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    </SitemapPage>
  );
}

export async function getServerSideProps({ resolvedUrl }) {
  const metadata = {
    title: `Explore Articles by Topic`,
    breadcrumbs: breadcrumbs(resolvedUrl),
  };

  return {
    props: {
      items: tags,
      metadata,
    },
  };
}

SitemapDirectoryArticles.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      core: PropTypes.bool,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          slug: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
  metadata: PropTypes.shape({
    title: PropTypes.string.isRequired,
    breadcrumbs: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
      })
    ).isRequired,
  }),
};
